export class Logo {
  constructor(
    public readonly name: string,
    public readonly rawData: string,
  ) {}
}
